/**
 * The Stripe key a card or account should be read with. A deployment used to
 * have exactly one, which is still the answer for anything whose integration
 * does not carry its own.
 */
export const stripePublishableKey = (fromIssuer?: string | null): string =>
  fromIssuer || (process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string);

export default stripePublishableKey;
